export default __webpack_public_path__ + "static/media/Snd_LowerDDownBump.b809cbcf.mp3";